import { useEffect, useLayoutEffect } from "react";

/** Sets document.title and the meta description, creating the meta tag if index.html lacks one. */
export function applyPageMeta(title: string, description: string): void {
  document.title = title;
  let meta = document.head.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "description";
    document.head.appendChild(meta);
  }
  meta.content = description;
}

/**
 * BR-WEB-004 — a page sets its own unique title and meta description.
 *
 * Runs as a passive effect, so a page that calls it wins over the route-level default the registry
 * applies (useRouteMeta, a layout effect) — e.g. a product page titling itself by product name.
 * index.html keeps <title>Greatway Patios</title> for the deploy smoke; this only changes the live DOM.
 */
export function usePageMeta(title: string, description: string): void {
  useEffect(() => {
    applyPageMeta(title, description);
  }, [title, description]);
}

/** Route-level default meta from the registry entry. Layout effect: runs before any page's usePageMeta. */
export function useRouteMeta(title: string, description: string): void {
  useLayoutEffect(() => {
    applyPageMeta(title, description);
  }, [title, description]);
}
